import {
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalCloseButton,
  Modal,
  ModalFooter,
  Button,
  Box,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  useDisclosure,
  Td,
} from '@chakra-ui/react'

export function MaisInformacoes({ infoCaixas }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  console.log(infoCaixas)

  return (
    <>
      <Button onClick={onOpen} colorScheme="blue">
        Mais Informações
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="3xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Informações de caixas</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box>
              <Table>
                <Thead>
                  <Tr>
                    <Th>Codigo do Produto</Th>
                    <Th>Última alteração</Th>
                    <Th>Caixa utilizada</Th>
                    <Th>Usuário alteração</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {infoCaixas.map((info) => (
                    <Tr key={info.id}>
                      <Td textAlign="center">{info.codigo_produto}</Td>
                      <Td textAlign="center">{info.ultima_data_alteracao}</Td>
                      <Td textAlign="center">{info.caixa}</Td>
                      <Td textAlign="center" textTransform="capitalize">
                        {info.nome_usuario_alteracao?.toLowerCase()}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
